import { Users } from 'lucide-react';

export default function EmptyGroups() {
  return (
    <div className="flex min-h-[320px] flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-white px-6 py-12 text-center shadow-sm">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-blue-100 text-blue-700">
        <Users className="h-7 w-7" />
      </div>
      <h2 className="mb-2 text-xl font-bold text-gray-900">No Lists Found</h2>
      <p className="mb-0 max-w-sm text-sm text-gray-600">No groups available under this category.</p>
    </div>
  );
}
